import { render, staticRenderFns } from "./NoticeNew.vue?vue&type=template&id=3e9a0134&"
import script from "./NoticeNew.vue?vue&type=script&lang=js&"
export * from "./NoticeNew.vue?vue&type=script&lang=js&"
import style0 from "./NoticeNew.vue?vue&type=style&index=0&id=3e9a0134&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports